<template>
  <div class="tmsView">
    <div class="tmsTitleImg">
        <img src="./img/tms.png" alt="">
    </div>
    <div class="tmsA">
        <img class="image" src="./img/tmsA.png" alt="">
    </div>
    <div class="tmsCenter">
        企业在
        <span>运输管理</span>
        方面存在的问题
    </div>
    <div class="tmsCenter">
        <img class="image" src="./img/tmsB.png" alt="">
    </div>
    <div class="tmsCenter">
        时空TMS助您实现
        <span>运输管理全流程</span>
    </div>
    <div class="tmsCenter">
        <img class="image" src="./img/tmsC.png" alt="">
    </div>
    <div class="tmsCenter">
        <img class="image" src="./img/tmsD.png" alt="">
    </div>
    <div class="tmsCenter text">
        <span>TMS全流程管理</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tmsView'
}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.tmsTitleImg{
    width: 750px/$md;
    height: 300px/$md;
    overflow: hidden;
    display: flex;
    justify-content: center;
    img{
        height: 100%;
    }
}
.image{
    width: 100%;
    height: 100%;
}
.tmsA{
    width: 243px/$md;
    height: 107px/$md;
    margin: 50px/$md auto;
}
.tmsCenter{
    padding:0 30px/$md 30px/$md 30px/$md;
    font-size: 28px/$md;
    font-weight: 400;
    span{
        color: #FF0000;
    }
}
.text{
    display: flex;
    justify-content: center;
}
</style>
